import { getWindowScrollTop } from './utils';

class MagicHeader {
  constructor(header, eventBus) {
    this.header = header;
    this.eventBus = eventBus;
    this.lastScrollTop = getWindowScrollTop();
    this.limit = 200;

    this.handleScroll = this.handleScroll.bind(this);
    this.bindEventListeners();
  }

  bindEventListeners() {
    this.eventBus.subscribe('scrollPosition', this.handleScroll);
  }

  handleScroll(scrollTop) {
    if (scrollTop >= this.limit && scrollTop > this.lastScrollTop) {
      // downscroll
      this.hideHeader();
    } else {
      // upscroll
      this.showHeader();
    }

    this.lastScrollTop = scrollTop;
  }

  hideHeader() {
    this.header.classList.add('is-hidden');
  }

  showHeader() {
    this.header.classList.remove('is-hidden');
  }
}

export default MagicHeader;